import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useStatements from 'context/statements/useStatements';
import useAccounts from 'context/useAccounts';

import FocusableHeader from 'components/focusableheader/FocusableHeader';

import Dropdown from '../dropdown/Dropdown';

import StatementList from './StatementList';
import StatementMailPreference from './StatementMailPreference';
import StatementsGuide from './StatementsGuide';

const Statements = () => {
    const { formatMessage } = useIntl();
    const { accounts, activeAccount, setActiveAccountIndex } = useAccounts();
    const { fetchStatements } = useStatements();
    const [selectedStatementsPeriod, setStatementsPeriod] = useState('last6Months');

    useEffect(() => {
        if (!activeAccount.hasStatements) {
            return;
        }
        fetchStatements(activeAccount.accountNumber);
    }, [activeAccount]);

    const handleDropdown = (e) => {
        const selectedAccountNumber = e.target.value;
        const i = accounts.findIndex(({ accountNumber }) => accountNumber === selectedAccountNumber);
        setActiveAccountIndex(i);
    };

    const dropdownOptions = accounts.map((account) => ({
        name: account.merchantName,
        value: account.accountNumber,
    }));

    const statementsPeriodOptions = [
        {
            name: formatMessage({ id: 'statements.period.six.months' }),
            value: 'last6Months',
        },
        {
            name: formatMessage({ id: 'statements.period.twelve.months' }),
            value: 'last6-12Months',
        },
        {
            name: formatMessage({ id: 'statements.period.eighteen.months' }),
            value: 'last12-18Months',
        },
        {
            name: formatMessage({ id: 'statements.period.twentyfour.months' }),
            value: 'last18-24Months',
        },
    ];

    return (
        <div className="statements">
            <FocusableHeader className="page-title">
                <FormattedMessage id="statements.page.title" />
            </FocusableHeader>
            <div className="statements-accounts-container">
                {accounts && accounts.length > 1 ? (
                    <>
                        <h3>
                            <FormattedMessage id="statements.account.select" />
                        </h3>
                        <Dropdown
                            id="accounts"
                            name="accounts"
                            onChange={handleDropdown}
                            options={dropdownOptions}
                            value={activeAccount.accountNumber}
                        />
                    </>
                ) : (
                    <>
                        <h3>
                            <FormattedMessage id="statements.account.name" />
                        </h3>
                        <div className="statements-account-name">{activeAccount.merchantName}</div>
                    </>
                )}
            </div>
            <div className="statements-list-container">
                <div className="statements__block">
                    <h3>
                        <FormattedMessage id="statements.period.select" />
                    </h3>
                    <Dropdown
                        id="select-statements-period"
                        name="select-statements-period"
                        onChange={(e) => setStatementsPeriod(e.target.value)}
                        options={statementsPeriodOptions}
                        value={selectedStatementsPeriod}
                    />
                    <div className="statements-period-hint">
                        <FormattedMessage id="statements.period.hint" />
                    </div>
                    {activeAccount.hasStatements ? (
                        <StatementList
                            accountNumber={activeAccount.accountNumber}
                            selectedStatementsPeriod={selectedStatementsPeriod}
                        />
                    ) : (
                        <StatementMailPreference />
                    )}
                </div>
            </div>
            <div className="statements-guide-container">
                <StatementsGuide />
            </div>
            <div className="statement-contact-container">
                <p>
                    <FormattedMessage id="statements.statement.contact" />
                </p>
            </div>
        </div>
    );
};

export default Statements;
